import { render, staticRenderFns } from "./domainName.vue?vue&type=template&id=06b6995c&"
import script from "./domainName.vue?vue&type=script&lang=js&"
export * from "./domainName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06b6995c')) {
      api.createRecord('06b6995c', component.options)
    } else {
      api.reload('06b6995c', component.options)
    }
    module.hot.accept("./domainName.vue?vue&type=template&id=06b6995c&", function () {
      api.rerender('06b6995c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configure/domainName.vue"
export default component.exports